export var Method;
(function (Method) {
    Method["LINK"] = "link";
    Method["VIEW"] = "view";
})(Method || (Method = {}));
export var Action;
(function (Action) {
    Action["CLICK"] = "click";
    Action["ERROR"] = "error";
    Action["VISIBLE"] = "visible";
})(Action || (Action = {}));
export const EventName = {
    CLICK: ['buttonClick'],
    ERROR: ['formError'],
};
export var Error;
(function (Error) {
    Error["FORM_FIELD"] = "formField";
    Error["FORM_VALIDATION"] = "formValidation";
})(Error || (Error = {}));
export const NO_VALUE = 'noValue';
export const pageLoginSources = [
    'RegistrationPage',
    'LoginPage',
    'resetPasswordPage',
];
export const twoStepComponentStates = {
    login: 'loginForm',
    registration: 'registerForm',
    emailAddress: 'emailVerificationForm',
};
export const getComponentTrackingNames = (navigationContext, formType) => {
    const componentNames = {
        modal: {
            login: 'candidateLoginModal',
            registration: 'candidateRegistrationModal',
            resetPassword: 'resetPasswordModal',
            registrationSuccessSimple: 'postRegistrationProfileCreatedWelcomeModal',
            twoStepLoginRegistration: 'candidateLoginRegisterModal',
        },
        page: {
            login: 'candidateLoginPage',
            registration: 'candidateRegistrationPage',
            resetPassword: 'resetPasswordPage',
            registrationSuccess: 'accountCreationSuccessPage',
            googleSuccess: 'googleAuthRedirect',
        },
        formEmbedder: {
            twoStepLoginRegistration: 'candidateLoginRegisterModal',
        },
    };
    return (componentNames?.[navigationContext]?.[formType] ||
        'unknownComponentName');
};
//# sourceMappingURL=constants.js.map